```vue
<script>
import {defineComponent} from 'vue'
import {IonPage} from "@ionic/vue";
import {AppApi} from "@/api/AppApi";
import NumberInput from "@/components/NumberInput.vue";
import AjaxForm from "@/components/AjaxForm.vue";
import DateInput from "@/components/DateInput.vue";
import {printDate} from "@/shared/helper";

export default defineComponent({
  name: "CustomerInfoForm",

  components: {
    DateInput,
    AjaxForm,
    NumberInput,
    IonPage
  },

  data()
  {
    return {
      id: this.$route.params.id,
      infoObj: null,
      error: null,

      // فقط newFields
      fields: [],

      // مقادیر فرم
      object: {},

      customer: null,
      pagePath: this.$route.path,
    }
  },

  methods: {

    search(array, item)
    {
      if (!Array.isArray(array))
        return false;

      item = item ? item.toString() : item;

      return array.some(x => {
        return x && x.toString() === item;
      });
    },

    async initPage()
    {
      this.id = this.$route.params.id;

      const res = await AppApi.getCustomerVisitForm(this.id);

      if (res.ok)
      {
        const visitForm = res.visitForm || {};

        /*
         * newFields ساختار جدید فرم است.
         * دیگر از res.fields استفاده نمی‌کنیم.
         */
        this.fields = res.newFields || [];

        /*
         * فقط مقدار فیلدهایی که در فرم جدید وجود دارند
         * از اطلاعات قبلی برداشته می‌شوند.
         */
        const object = {};

        for (const category of this.fields)
        {
          if (!category.fields)
            continue;

          for (const f of category.fields)
          {
            if (Object.prototype.hasOwnProperty.call(visitForm, f.slug))
            {
              object[f.slug] = visitForm[f.slug];

              if (
                  f.type === 'date' &&
                  object[f.slug]
              )
              {
                object[f.slug] = printDate(object[f.slug]);
              }
            }
          }
        }

        this.object = object;
        this.customer = res.customer;
      }
      else
      {
        this.error = res.error;
      }
    },
  },

  watch: {
    "$route.fullPath": {
      handler(n, o)
      {
        if (
            this.$route.path === this.pagePath &&
            this.$route.fullPath != o
        ) {
          this.initPage();
        }
      },

      deep: true,
      immediate: true,
    },
  }
})
</script>

<template>
  <ion-page>

    <master-layout pageTitle="فرم ویزیت مشتری">

      <div class="card main-card">

        <div class="card-body ">

          <ajax-form
              v-if="customer"
              :route="'CustomerVisitForm/submit/'+id"
          >

            <!-- اطلاعات مشتری -->
            <div class="customer-info">
              <div class="customer-avatar">
                {{ customer.fullname ? customer.fullname.charAt(0) : '؟' }}
              </div>
              <div class="customer-meta">
                <div class="customer-title">فرم ویزیت مشتری</div>
                <div class="customer-details">
                  <span>{{ customer.fullname }}</span>
                  <span class="customer-separator">•</span>
                  <span>{{ customer.phone }}</span>
                </div>
              </div>
            </div>


            <!-- دسته بندی ها -->
            <div
                v-for="category in fields"
                :key="category._id"
                class="category-box"
            >
              <template v-if="category.fields && category.fields.length">
                <!-- عنوان دسته بندی -->
                <div class="category-header">

                  <div class="category-icon">
                    <span>{{ category.fields.length }}</span>
                  </div>

                  <div class="category-title">
                    {{ category.title }}
                  </div>

                </div>


                <!-- فیلدهای دسته بندی -->
                <div
                    v-if="category.fields && category.fields.length"
                    class="category-body"
                >

                  <div
                      class="form-field"
                      v-for="f in category.fields"
                      :key="f._id"
                  >

                    <!-- number -->
                    <div v-if="f.type === 'number'">

                      <label>
                        {{ f.title }}
                      </label>

                      <number-input
                          :name="f.slug"
                          :value="
                        object && object[f.slug] !== undefined
                          ? object[f.slug]
                          : ''
                      "
                      />

                    </div>


                    <!-- phone -->
                    <div v-if="f.type === 'phone'">

                      <label>
                        {{ f.title }}
                      </label>

                      <input
                          class="form-control"
                          type="tel"
                          :name="f.slug"
                          :value="
                        object && object[f.slug] !== undefined
                          ? object[f.slug]
                          : ''
                      "
                      />

                    </div>


                    <!-- short text -->
                    <div v-if="f.type === 'short_text'">

                      <label>
                        {{ f.title }}
                      </label>

                      <input
                          class="form-control"
                          type="text"
                          :name="f.slug"
                          :value="
                        object && object[f.slug] !== undefined
                          ? object[f.slug]
                          : ''
                      "
                      />

                    </div>


                    <!-- date -->
                    <div v-if="f.type === 'date'">

                      <label>
                        {{ f.title }}
                      </label>

                      <date-input
                          :name="f.slug"
                          v-model="object[f.slug]"
                      />

                    </div>


                    <!-- long text -->
                    <div v-if="f.type === 'long_text'">

                      <label>
                        {{ f.title }}
                      </label>

                      <textarea
                          class="form-control"
                          :name="f.slug"
                          :value="object && object[f.slug] !== undefined ? object[f.slug] : ''"
                      ></textarea>

                    </div>


                    <!-- multi select -->
                    <div v-if="f.type === 'multi_select'">

                      <label>
                        {{ f.title }}
                      </label>

                      <div class="options-container">

                        <div
                            v-for="(x,index) in f.values"
                            :key="index"
                            class="option-item"
                        >

                          <input
                              :value="x"
                              autocomplete="off"
                              type="checkbox"
                              class="custom-control-input"
                              :id="'t_'+index.toString()+f._id"
                              :checked="
                            object &&
                            object[f.slug] &&
                            search(object[f.slug], x)
                          "
                              :name="f.slug+'[]'"
                          >

                          <label
                              class="custom-control-label"
                              :for="'t_'+index.toString()+f._id"
                          >
                            {{ f.values_lable[index] }}
                          </label>

                        </div>

                      </div>

                    </div>


                    <!-- select -->
                    <div v-if="f.type === 'select'">

                      <label>
                        {{ f.title }}
                      </label>

                      <div class="options-container">

                        <div
                            v-for="(x,index) in f.values"
                            :key="index"
                            class="option-item"
                        >

                          <input
                              :value="x"
                              autocomplete="off"
                              type="radio"
                              class="custom-control-input"
                              :id="'t_'+index.toString()+f._id"
                              :checked="
                            object &&
                            object[f.slug] !== undefined &&
                            search([object[f.slug]], x)
                          "
                              :name="f.slug"
                          >

                          <label
                              class="custom-control-label"
                              :for="'t_'+index.toString()+f._id"
                          >
                            {{ f.values_lable[index] }}
                          </label>

                        </div>

                      </div>

                    </div>

                  </div>

                </div>


                <!-- دسته بندی بدون فیلد -->
                <div
                    v-else
                    class="empty-category"
                >
                  فیلدی برای این دسته‌بندی ثبت نشده است.
                </div>
              </template>



            </div>


            <!-- دکمه ثبت -->
            <div class="submit-container">

              <button
                  type="submit"
                  class="btn btn-info btn-block submit-button"
              >
                ثبت اطلاعات
              </button>

            </div>

          </ajax-form>


          <!-- خطا -->
          <div
              v-if="error"
              class="alert alert-danger"
          >
            {{ error }}
          </div>

        </div>

      </div>

    </master-layout>

  </ion-page>
</template>

<style scoped>

/* ---------- کارت اصلی ---------- */
.main-card {
  border: 0;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(75, 31, 61, 0.08);
  background: #fff;
}

.card-body {
  padding: 18px;
}

/* ---------- اطلاعات مشتری ---------- */
.customer-info {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  margin-bottom: 22px;
  border-radius: 14px;
  background: linear-gradient(135deg, #f6f0fb 0%, #fdf7ff 100%);
  border: 1px solid #ece2f5;
  position: relative;
  overflow: hidden;
}

.customer-info::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #8a5cb8, #b48ad6);
}

.customer-avatar {
  width: 46px;
  height: 46px;
  border-radius: 50%;
  background: linear-gradient(135deg, #8a5cb8, #b48ad6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  flex-shrink: 0;
  box-shadow: 0 3px 8px rgba(138, 92, 184, 0.3);
}

.customer-meta {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1;
}

.customer-title {
  font-size: 15px;
  font-weight: bold;
  color: #4b1f3d;
}

.customer-details {
  font-size: 13px;
  color: #6b5b73;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

.customer-separator {
  color: #c4b3ce;
}

/* ---------- دسته‌بندی ---------- */
.category-box {
  border: 1px solid #ede7f2;
  border-radius: 14px;
  margin-bottom: 18px;
  overflow: hidden;
  background: #fff;
  transition: box-shadow 0.2s ease;
}

.category-box:hover {
  box-shadow: 0 4px 14px rgba(75, 31, 61, 0.06);
}

.category-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 13px 16px;
  background: linear-gradient(90deg, #f9f6fc 0%, #fdfbff 100%);
  border-bottom: 1px solid #ede7f2;
}

.category-icon {
  min-width: 26px;
  height: 26px;
  padding: 0 7px;
  border-radius: 13px;
  background: #e7dff0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #76568a;
  font-size: 12px;
  font-weight: bold;
}

.category-title {
  font-size: 14.5px;
  font-weight: bold;
  color: #4b1f3d;
  flex: 1;
}

.category-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ---------- فیلدها ---------- */
.form-field {
  margin: 0;
}

.form-field label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 7px;
}

.form-control {
  border-radius: 9px;
  border: 1px solid #e2dbe8;
  min-height: 42px;
  padding: 8px 12px;
  font-size: 14px;
  transition: border-color 0.15s, box-shadow 0.15s;
  background: #fdfcfe;
}

.form-control:focus {
  border-color: #b48ad6;
  box-shadow: 0 0 0 3px rgba(180, 138, 214, 0.15);
  outline: none;
  background: #fff;
}

textarea.form-control {
  min-height: 95px;
  resize: vertical;
}

/* ---------- گزینه‌ها (چیپ) ---------- */
.options-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.option-item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 13px;
  background: #faf8fc;
  border: 1px solid #e8e1ee;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.15s ease;
  user-select: none;
}

.option-item:hover {
  border-color: #c9b3dd;
  background: #f5eefb;
}

.option-item input {
  margin: 0;
  cursor: pointer;
  accent-color: #8a5cb8;
}

.custom-control-label {
  margin: 0 !important;
  font-size: 13px !important;
  font-weight: normal !important;
  color: #4b4453;
  cursor: pointer;
}

/* ---------- دسته خالی ---------- */
.empty-category {
  padding: 16px;
  color: #a99bb0;
  font-size: 13px;
  text-align: center;
  background: #fbf9fc;
}

/* ---------- دکمه ثبت ---------- */
.submit-container {
  margin-top: 24px;
}

.submit-button {
  width: 100%;
  border: none;
  border-radius: 11px;
  min-height: 48px;
  font-size: 15px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(135deg, #8a5cb8 0%, #a478cc 100%);
  box-shadow: 0 4px 14px rgba(138, 92, 184, 0.3);
  transition: transform 0.15s, box-shadow 0.15s;
}

.submit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(138, 92, 184, 0.4);
  color: #fff;
}

.submit-button:active {
  transform: translateY(0);
}

/* ---------- ریسپانسیو ---------- */
@media (max-width: 480px) {
  .card-body {
    padding: 12px;
  }

  .customer-info {
    padding: 12px 14px;
    gap: 10px;
  }

  .customer-avatar {
    width: 40px;
    height: 40px;
    font-size: 17px;
  }

  .category-body {
    padding: 12px;
    gap: 12px;
  }

  .options-container {
    flex-direction: column;
    align-items: stretch;
  }

  .option-item {
    justify-content: flex-start;
  }
}

</style>